const messages = {
  title: "Prämienshop",
  description: "Herzlich willkommen im Prämienshop. Hier können Sie Ihre Bridgestone Plus Punkte gegen Prämien aus verschiedenen Kategorien einlösen. Das Angebot an Produkten wird regelmässig aktualisiert. Wir wünschen viel Spass beim Stöbern.",
  sort: {
    asc: "Sortieren nach: Niedrigster Preis",
    desc: "Sortieren nach: Höchster Preis",
  },
  productSearchBox: {
    from: "ab Punktewert",
    to: "bis Punktewert",
  },
  noProducts: "Die Suchkriterien ergaben keine Treffer",
  quantity: "Menge",
  search: "Suche",
  perPage: "Artikel pro Seite",
  timeUnavailable: "Zur Zeit nicht lieferbar",
  product: "Produkt",
  cart: {
    pointsPerUnit: "Punkte / Einheit",
    pointsSum: "Punkte",
  },
  action: "Aktion",
  pointsTotal: "Punkte insgesamt",
  cartRemainPoints: "Punkte verbleibend",
  shoppingCart: "Warenkorb",
  emptyCart: "Warenkorb ist leer.",
  attributes: "Attribute",
  selectAddressP: "Bitte wählen Sie Ihre Lieferadresse aus",
  orderDelivery: "Lieferadresse",
  selectedProducts: "Ausgewählte Produkte",
  orderSummary: "Bestellübersicht",
  contactPerson: "Ansprechpartnerin",
  selectedAddress: "Ausgewählte Adresse",
  order: {
    success: "Vielen Dank! Ihre Bestellung war erfolgreich. Sie erhalten in wenigen Minuten eine Bestellbestätigung in Ihr Postfach.",
    description: "Hier finden Sie eine Übersicht Ihrer Prämienshop-Bestellungen.",
    info: "Hier finden Sie eine Übersicht Ihrer Prämienshop-Bestellungen.",
    date: "Bestelldatum",
    number: "Bestellnr.",
    status: {
      created: "Erstellt",
      confirm_order: "Bestellung bestätigen",
      ready_for_shipment: "Versandfertig",
      rejected: "Abgelehnt",
      processed: "Verarbeitet",
      shipped: "Versendet",
      returned: "Ist zurückgekommen",
      finished: "Fertig",
    },
    anyOrder: "Keine Befehle",
    products: "Produkte",
    quantity_short: "Stk",
    itemRemoved: "nicht lieferbar",
  },
  orders: "Bestellungen",
  notEnoughPoints: "Nicht genügend Punkte vorhanden.",
  statusText: "Status",
  outOfStock: "Derzeit nicht auf Lager",
  productUnavailable: "Dieses Produkt ist nicht mehr verfügbar.",
  deletedProductsTitle: "Produkte nicht mehr verfügbar",
  deletedProductsMessage: "Die folgenden Produkte sind nicht mehr verfügbar. Bitte entfernen Sie sie aus dem Warenkorb, um fortzufahren.",
  removeSelected: "Auswahl entfernen",
  clearCart: "Warenkorb leeren",
  removeSelectedConfirm: "Die ausgewählten Produkte aus dem Warenkorb entfernen?",
  clearCartConfirm: "Alle Produkte aus dem Warenkorb entfernen?",
  favoriteProducts: {
    description: "Hier finden Sie die von Ihnen gespeicherten Produkte.",
  },
  incompleteAddress: {
    firstName: "Bitte fügen Sie der Lieferadresse einen Vornamen hinzu",
    lastName: "Bitte fügen Sie der Lieferadresse einen Nachnamen hinzu",
    company: "Bitte fügen Sie der Lieferadresse einen Firmennamen hinzu",
    street: "Bitte fügen Sie der Lieferadresse eine Straße und Hausnummer hinzu",
    postalCode: "Bitte fügen Sie der Lieferadresse eine Postleitzahl hinzu",
    city: "Bitte fügen Sie der Lieferadresse einen Ort hinzu",
    country: "Bitte fügen Sie der Lieferadresse ein Land hinzu",
    phone: "Bitte fügen Sie der Lieferadresse eine Telefonnummer hinzu",
  },
  variant: "Varianten wählbar",
  placeOrder: "Verbindlich Bestellen",
  toOrderDelivery: "Weiter zur Lieferadresse",
  toOrderSummary: "Zur Bestellübersicht",
  productImg: "Produktbild",
  selectAddressBtn: "Adresse auswählen",
  perPgae: "Artikel pro Seite",
  categories: {
    advertising: {
      title: "Werbemittel",
      desc: "Direkt hier auf der Plattform teilnehmen und <br/> 40 Extrapunkte für den Prämienclub sichern.",
    },
    rewards: {
      title: "Exklusiv-Prämien",
      desc: "Entdecken Sie das Pramienangebot in <br/>unserem Trainingscenter oder bei Ihnen vor Ort.",
    },
    tools: {
      title: "Werkstatt-Tools",
      desc: "Setzen Sie Ihre Punkte für Drittanbieter- <br/> Trainings ein und reduzieren Sie so Ihre Kosten.",
    },
    trainings: {
      title: "Trainings & Schulungen",
      desc: "Entdecken Sie das Prämienangebot in unserem Trainingscenter oder bei Ihnen vor Ort.",
    },
    salesroom: {
      title: "Verkaufsraum",
      desc: "Verkaufsraum in Szene setzen und Ihrem Kunden einen angenehmen Aufenthalt bieten.",
    },
    hunter: {
      title: "Werkstatteinrichtungen",
      desc: "Punkte gegen attraktive Werkstatt-Ausrüstung von Werkstatteinrichtungen eintauschen.",
    },
  },
  bestSold: "Meistgekauft",
  seasonal: "Saisonales",
  affordable: "Fast geschafft",
  forPoints: "für {points} Punkte",
  reachedPoints: "Benötigten Punktestand erreicht",
  remainingPoints: "{points} Punkte noch fehlend",
  categoryPageDescriptionFallback: "Material für die Werkstatt oder andere qualitative Produkte mit dem Bridgestone-Logo für Ihr Unternehmen",
};
export default {
  messages,
};
